import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref } from 'vue';
import IconButton from '../common/base/IconButton.vue';
import TUIMessageBox from '../common/base/MessageBox/index';
import AudioSettingTab from '../common/AudioSettingTab.vue';
import AudioIcon from '../common/AudioIcon.vue';
import { useI18n } from '../../locales';
import '../../directives/vClickOutside';
import { isGetUserMediaSupported, isEnumerateDevicesSupported } from '../../utils/mediaAbility';

interface Props {
  hasMore?: boolean,
  isMuted: boolean,
  isDisabled?: boolean,
  audioVolume: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioMediaControl',
  props: {
    hasMore: { type: Boolean, default: true },
    isMuted: { type: Boolean },
    isDisabled: { type: Boolean, default: false },
    audioVolume: { default: 0 }
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {




const showAudioSettingTab: Ref<boolean> = ref(false);
const isSupportAudioMedia = isGetUserMediaSupported && isEnumerateDevicesSupported;
const { t } = useI18n();

async function handleClickIcon() {
  if (!isSupportAudioMedia) {
    TUIMessageBox({
      title: t('Note'),
      message: t('The current browser does not support capturing audio'),
      appendToRoomContainer: true,
      confirmButtonText: t('Sure'),
    });
    return;
  }
  emits('click');
  showAudioSettingTab.value = false;
}

function handleMore() {
  showAudioSettingTab.value = !showAudioSettingTab.value;
}

function handleHideAudioSettingTab() {
  if (showAudioSettingTab.value) {
    showAudioSettingTab.value = false;
  }
}


return { __sfc: true,emits, showAudioSettingTab, isSupportAudioMedia, t, handleClickIcon, handleMore, handleHideAudioSettingTab, IconButton, AudioSettingTab, AudioIcon }
}

})